import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CultureROI from './components/CultureROI';
import Experience from './components/Experience';
import Differentiator from './components/Differentiator';
import PerfectFor from './components/PerfectFor';
import PlanningEarly from './components/PlanningEarly';
import LeadForm from './components/LeadForm';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-spanish-ivory selection:bg-antique-gold selection:text-mission-dark">
      <Navbar />
      <Hero />
      <CultureROI />
      <Experience />
      <Differentiator />
      <PerfectFor />
      <PlanningEarly />
      <LeadForm />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;